import Modal from 'shared/migration-components/modal';
import NotFound from 'shared/layout/not-found';
import useAccessControls from 'modules/access-controls/atoms/use-access-controls';

interface GetModalProps {
  title?: string;
  element: React.ReactNode;
  permissions?: string[];
  hideDrawer?: boolean;
  size?: any;
  centered?: boolean;
  withCloseButton?: boolean;
}

const getModal = ({
  element,
  permissions,
  title,
  size,
  centered,
  withCloseButton = true,
}: GetModalProps) => {
  const {isModuleAllowed} = useAccessControls();
  if (permissions && !isModuleAllowed(permissions)) return <NotFound />;

  return (
    <Modal
      withCloseButton={withCloseButton}
      opened
      onClose={() => history.back()}
      title={title}
      size={size}
      centered={centered}>
      {element}
    </Modal>
  );
};

export default getModal;
